import { Injectable } from '@angular/core';

export let PARTNERSHIP: any = null;

@Injectable({
  providedIn: 'root'
})
export class LoadAppConfigService {
  public config: any = {};
}

export function setGlobalConfig(config: any) {
  PARTNERSHIP = config;
}
